import ReportTableYearModalController from "./ReportTableYearModalController";

class ReportYearService {

    constructor (private $uibModal: any, private elfiumUrlService: any, private elfiumRestService: any) {}

    public getReportYearsByBusinessCaseId (businessCaseId: string): any {
        var searchParameters = {
            obchodniPripadId: businessCaseId
        };
        return this.searchReportYears(searchParameters).then((reports) => reports);
    }

    private searchReportYears (searchParameters: any): any {
        return this.elfiumRestService.searchReportYears(searchParameters);
    };

    public removeReportYear (reportYearId: string): ng.IPromise<any> {
        return this.elfiumRestService.deleteReportYear(reportYearId);
    }

    public addReportYear (reportYear: any) {
        return this.elfiumRestService.createReportYear(reportYear);
    }

    public openEditDetailModal (businessCaseId: string) {
        let modalInstance = this.$uibModal.open({
            templateUrl:  this.elfiumUrlService.getTemplateUrl('report', 'reportTableYearModal'),
            controller: ReportTableYearModalController,
            windowClass: 'report-table-modal',
            backdrop: false,
            resolve: {
                businessCaseId: () => businessCaseId
            }
        });
        return modalInstance.result;
    };
}

ReportYearService.$inject = ['$uibModal', 'elfiumUrlService', 'elfiumRestService'];

angular.module('elfium').service('reportYearService', ReportYearService);

export default ReportYearService;


// WEBPACK FOOTER //
// ./src/app/components/report/ReportYearService.ts